import { Component, inject, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { SiteConfigFacade } from '@qwyk/portals/siteconfig';

export interface RequestedNavigation {
    component: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
}

const COMPONENTS = {
    REQUEST_PASSWORD_RESET: 'request-password-reset',
    RESET_PASSWORD: 'reset-password',
    RESEND_CONFIRMATION_EMAIL: 'resend-confirmation-email'
} as const;

@Component({
    selector: 'qwyk-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent implements OnInit {

    private readonly modalRef = inject(DynamicDialogRef);
    private readonly siteConfig = inject(SiteConfigFacade);
    private readonly config = inject(DynamicDialogConfig);

    component = 'login';
    navigationData = null;
    allowContinueWithoutLogin = false;
    components = COMPONENTS;

    design$ = this.siteConfig.design$;
    siteConfiguration$ = this.siteConfig.config$;
    isMagayaNetwork$ = this.siteConfig.isMagayaNetwork$;
    authenticationType$ = this.siteConfig.authenticationType$;

    ngOnInit(): void {
        if (this.config.data?.component) {
            this.component = this.config.data.component;
        }
    }

    closeDialog() {
        this.modalRef.close();
    }

    cancelDialog(reason?: string) {
        this.modalRef.close(reason);
    }

    onNavigationRequested(navigation: RequestedNavigation) {
        this.navigationData = navigation.data;
        this.component = navigation.component;
    }
}
